import { performLogin } from "../../apis";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { commitLoginSession } from "./session";

export function useLogin() {
  const queryClient = useQueryClient();

  const { mutate, data, error, status } = useMutation({
    mutationFn: ({ email, password }: { email: string; password: string }) => {
      return performLogin({ email, password });
    },
    onSuccess: (data) => {
      commitLoginSession(queryClient, data);
    },
  });

  return {
    performLogin: mutate,
    result: data,
    error,
    status,
    isLoading: status === "pending",
  };
}
